var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_25982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2605 2.99958C8.17052 2.85958 4.00052 6.94958 4.00052 11.9996H2.21052C1.76052 11.9996 1.54052 12.5396 1.86052 12.8496L4.65052 15.6496C4.85052 15.8496 5.16052 15.8496 5.36052 15.6496L8.15052 12.8496C8.46052 12.5396 8.24052 11.9996 7.79052 11.9996H6.00052C6.00052 8.09958 9.18052 4.94958 13.1005 4.99958C16.8205 5.04958 19.9505 8.17958 20.0005 11.8996C20.0505 15.8096 16.9005 18.9996 13.0005 18.9996C11.3905 18.9996 9.90052 18.4496 8.72052 17.5196C8.32052 17.2096 7.76052 17.2396 7.40052 17.5996C6.98052 18.0196 7.01052 18.7296 7.48052 19.0896C9.00052 20.2896 10.9105 20.9996 13.0005 20.9996C18.0505 20.9996 22.1405 16.8296 22.0005 11.7396C21.8705 7.04958 17.9505 3.12958 13.2605 2.99958ZM12.7505 7.99958C12.3405 7.99958 12.0005 8.33958 12.0005 8.74958V12.4296C12.0005 12.7796 12.1905 13.1096 12.4905 13.2896L15.6105 15.1396C15.9705 15.3496 16.4305 15.2296 16.6405 14.8796C16.8505 14.5196 16.7305 14.0596 16.3805 13.8496L13.5005 12.1396V8.73958C13.5005 8.33958 13.1605 7.99958 12.7505 7.99958Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_25982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.fdadc0061fc797c35570cc37179e01c8.svg";
export { ForwardRef as ReactComponent };